module.exports = __webpack_public_path__ + "img/1.3.1cf61d05.png";